export default __webpack_public_path__ + "static/media/cover-default.548984c6.jpg";